import { gateNames } from '@mp/constants';
import { useGate } from '@mp/hooks';
import {
  getMissingSpecialtiesOptions,
  hasMatchingSpecialtiesForHighRiskJob,
  JobPositionsProps,
  JobSpecialtiesProps,
  MissingHighRiskSpecialtiesProps,
} from '@mp/utils';

type UseRecommendedSpecialtiesDataParams = {
  jobPositions?: JobPositionsProps[] | null;
  jobSpecialties?: JobSpecialtiesProps[] | null;
  jobMissingHighRiskSpecialties?: MissingHighRiskSpecialtiesProps[] | null;
  userSpecialties?: JobSpecialtiesProps[] | null;
};

export const useRecommendedSpecialtiesData = ({
  jobPositions,
  jobSpecialties,
  userSpecialties,
  jobMissingHighRiskSpecialties,
}: UseRecommendedSpecialtiesDataParams) => {
  const showSpecialtySpeedbumExtension = useGate(gateNames.specialty_speedbump_extension);

  const highRiskSpecialtiesMissingForJob = jobMissingHighRiskSpecialties ?? [];

  const hasMissingHighRiskSpecialties = highRiskSpecialtiesMissingForJob.length > 0;
  const userHasAllRequiredSpecialtiesLegacy = hasMatchingSpecialtiesForHighRiskJob({
    jobPositions,
    jobSpecialties,
    userSpecialties,
  });

  const specialtyOptions = showSpecialtySpeedbumExtension
    ? highRiskSpecialtiesMissingForJob.map(({ specialty_id, label }) => ({
        value: specialty_id as number,
        label: label as string,
      }))
    : getMissingSpecialtiesOptions({
        jobSpecialties,
        userSpecialties,
      });

  return {
    userHasAllRequiredSpecialties: showSpecialtySpeedbumExtension
      ? !hasMissingHighRiskSpecialties
      : userHasAllRequiredSpecialtiesLegacy,
    specialtyOptions,
  };
};
